<div [class.is-filtered]="isFiltered">
  <div>
    <mat-form-field>
      <mat-label>Filter</mat-label>
      <input [formControl]="element" [matAutocomplete]="filterAutocomplete" matInput
             #filterAutocompleteTrigger type="text">
      <mat-autocomplete #filterAutocomplete="matAutocomplete"
                        [displayWith]="formatAutocomplete"
                        (optionSelected)="selectSearchedAddress($event.option.value.id)"
                        class="address-autocomplete">
        <mat-optgroup *ngIf="element.value" label="Zoeken">
          <mat-option [value]="{search: element.value}">{{ element.value }}</mat-option>
        </mat-optgroup>
        <mat-optgroup *ngIf="searchedAddressSuggestions" label="Selecteer locatie">
          <mat-option *ngFor="let option of searchedAddressSuggestions" [value]="option">
            <span [innerHTML]="option.weergavenaam"></span>
          </mat-option>
        </mat-optgroup>
      </mat-autocomplete>
      <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
    </mat-form-field>
    <button (click)="clearFilterButton()" [class.show]="isFiltered" mat-icon-button type="button">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>
